import { render, staticRenderFns } from "./saAside.vue?vue&type=template&id=df3961d0"
import script from "./saAside.vue?vue&type=script&lang=js"
export * from "./saAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports